export default __webpack_public_path__ + "static/E-Spark-Viridian-Award-0654119ac2467bb9e6cf9e128d9e8e14.jpg";